import React from 'react'
import PropTypes from 'prop-types'

const League = ({league, token, locationId}) => {
  const disableTeamReg = league.teamsSpace <= 0
  const disableIndReg = league.playersSpace <= 0


  const leagueUrl = (type) => {
    return `/plugin/leagues/${league.id}?token=${token}&location_id=${locationId}&type=${type}`
  }

  return (
    <div className='col-xs-12 col-sm-6 col-md-4'>
      <div className='league-card'>
        <a href={leagueUrl('team')}>
          <div className='league-desc'>
            <span className='league-name' title={league.fullName}>{league.fullName}</span>
            <span className='league-about'>{`Soccer ${league.sizeName} including goalie`}</span>
            <img src={league.photo} />
          </div>
        </a>
        <div className='league-date-info'>
          <span>{`• Day: ${league.days}`}</span>
          <span>{`• Starts: ${league.startDate}`}</span>
        </div>
        <div className='row'>
          <div className='col-xs-6'>
            <a href={leagueUrl('team')} className={'league-button' + (disableTeamReg ? ' disabled' : '')}>
              TEAM
            </a>
          </div>
          <div className='col-xs-6'>
            <a href={leagueUrl('individual')} className={'league-button' + (disableIndReg ? ' disabled' : '')}>
              FREE AGENT
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

League.propTypes = {
  league: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  locationId: PropTypes.number.isRequired,
}

export default League
